document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector(".hiw__cta");
  const target = document.querySelector(".hero-video-form");
  if (!btn || !target) return;
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    target.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  });
});